import _URL from '../../URL/index';
const axios = _URL.axios;


export default {
    services: {
        getOperators: (token) => {
            return axios(token).get(`/operators-options`);
        },
        updateOperatorById: (operatorId, operator,  token = "") => {
            return axios(token).put(`/operators/${operatorId}`, operator);
        },
    }
}